import React from 'react';
import { ShowIf } from 'components/utils';
import {msg} from "constants/message";
import {validatable} from 'components/utils';
import {ReactTreeSelect} from 'components/tt-forms/react-tree-select';

class DropDownTreeMultipleSelect extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      dataOptions: this.props.dataOptions,
      dataSelected: this.props.dataSelected,
      propertyChildren: this.props.propertyChildren,
      thanhTraCQQL: this.props.thanhTraCQQL,
      propertyParent: this.props.propertyParent,
      isValid: true
    }
  }

  onChange(e) {
    this.setState({
      dataSelected: e,
      isValid: true
    })
    this.props.onChange(e);
  }

  validate() {
    if (this.state.dataSelected.length == 0 && this.props.require) {
      this.setState({
        isValid: false
      });
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataOptions: nextProps.dataOptions || [],
      dataSelected: nextProps.dataSelected || [],
      propertyChildren: nextProps.propertyChildren,
      thanhTraCQQL: nextProps.thanhTraCQQL,
      propertyParent: nextProps.propertyParent,
    });
  }

  classNames() {
    if (!this.state.isValid && this.state.dataSelected.length == 0) {
      return 'rs-multiple-danger';
    } else {
      return '';
    }
  }

  unCheckSelectAllChildren() {
    this.props.unCheckSelectAllChildren();
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <ShowIf condition={this.props.label != ''}>
          <label className="ip-label">
            { this.props.label }
            <ShowIf condition={this.props.require == true}>
              <span className="text-required">&nbsp;*</span>
            </ShowIf>
          </label>
          </ShowIf>
        <div className={this.classNames()}>
          <ReactTreeSelect
            data={this.state.dataOptions}
            name={this.props.name}
            dataOptions={this.props.dataOptions}
            dataSelected={this.state.dataSelected}
            onChange={this.onChange.bind(this)}
            propertyChildren={this.state.propertyChildren}
            thanhTraCQQL={this.props.thanhTraCQQL}
            propertyParent={this.state.propertyParent}
            optionOpened={this.state.optionOpened}
            selectAllChildren={this.props.selectAllChildren}
          />
        </div>

        <ShowIf condition={!this.state.isValid && this.state.dataSelected.length == 0}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
      </div>
      );
  }
}

DropDownTreeMultipleSelect.defaultProps = {
  className: 'input-group',
  label: '',
  dataOptions: [],
  dataSelected: [],

  onChange: function() {
    console.log('Need to assign onChange method');
  },
  value: [],
  keyName: 'key',
  propertyChildren: '',
  propertyParent: '',
  require: false
}

export default validatable(DropDownTreeMultipleSelect);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/DropDownTreeMultipleSelect.jsx